/**
 * PlusCards
 * ======================================
 */

 const ELEMENTS = '.js-PlusCards'
 const SUB_ELEMENT = '.slideToggle'
 const TOGGLE_CLASS = 'is-open'
 const DEFAULTACTIVECLASS = 'is-open-default'

 class PlusCards {
   constructor() {
    this.elements = document.querySelectorAll(ELEMENTS);

    if (!this.elements) {
      return false;
    }

    this.elements.forEach((el) => {
      const nav = el.querySelectorAll('.plus-cards__item-header')

      nav.forEach((navEl) => {
        navEl.addEventListener('click', this.toggle)
      })

      document.addEventListener('DOMContentLoaded', () => {
          this.initOpen(el)
      });

    });
   }

   initOpen = (widget) => {
    const activeTab = widget.querySelector('.plus-cards__item.'+DEFAULTACTIVECLASS)
    const sub = activeTab.querySelector(SUB_ELEMENT)

    sub.style.height = sub.scrollHeight+'px'
    activeTab.classList.remove(DEFAULTACTIVECLASS)
  }

   toggle = (e) => {
    const el = e.currentTarget;
    const target = el.parentNode;
    const classes = target.classList
    const sub = target.querySelector(SUB_ELEMENT)

    if(classes.contains(TOGGLE_CLASS)){
      classes.remove(TOGGLE_CLASS)
      sub.style.height = 0
    } else {
      classes.add(TOGGLE_CLASS)
      sub.style.height = sub.scrollHeight+'px'
    }

    e.preventDefault();
  };
 }

 new PlusCards()
